<template>

	<body>
		<div>
			<div class="bannerWrap">
				<div class="banner">
					<img src="../assets/2015100910563038.jpg" alt='' title='' />
				</div>
				<div class="bannerText">
					<img src="../assets/2018070417064416.png" alt title />
				</div>
			</div>
			<div class="mainWrap">
				<div class="main">
					<div class="breadCrumbs">
						<h3>{{product.name}}</h3>
						<span>
                <a >首页</a> &gt;
                <a @click="product()">产品</a> &gt;
                <em>{{product.name}}</em>
            </span>
					</div>
					<!--内容开始-->
					<div class="mainWrap">
						<div class="main proWrap">
							<div class="breadCrumbs">
								<h3>登录</h3>
								<span>
                <a href="/index.html">首页</a> &gt;
                <em>登录</em>
            </span>
							</div>
							<!--内容开始-->
							<div class="content">
								<div class="crLoginform-wrapper">
									<form class="crLoginform">
										<ul>
											<li><span>用户名：</span><input type="text" value="user.username" id="txtUserName"></li>
											<li><span>密码：</span><input type="password" value="user.userpassword" id="txtUserPwd"></li>
											<li>
												<a class="crForget" href="/resetpassword.html">忘记密码？</a>
											</li>
											<li class="crLoginLi"><span>&nbsp;</span><input type="submit" class="crLoginBtn" id="btnLogin" value="登录"><input type="submit" class="crLoginBtn2" onclick="location.href = '/register.html'; return false;" value="注册"></li>
										</ul>
									</form>
								</div>
							</div>
</div>
							</div>
							<!--内容结束-->
						</div>
					</div>

				</div>
	</body>
</template>

<script>
	export default {
		data() {
			return {
user:{
	username:'',
	userpassword:''
	
},
				product: {

					id: 1,
					name: '限量版耳机（1LE）',
					titel: '1LE',
					price: '￥1680.00',
					image: require('../assets/2016120817393507.png'),
					detail: ' 1周年限量版（已售罄）'
				}
			}
		},
		methods: {

			purchase() {

				this.$router.push('/WirelessHeadset')

			}
		},
		mounted() {

		}
	}
</script>

<style scoped>
	@import '../../static/newlayout.css';
</style>


// WEBPACK FOOTER //
// src/views/login.vue